import { useMutation } from '@tanstack/react-query'
import apiClient from '@/lib/api/client'
import type { ApiResponse } from '@/lib/api/types'

/** 주소 검색 결과 항목 */
export interface LocationSearchResult {
  addressName: string
  latitude: number
  longitude: number
}

/**
 * 카카오 주소 검색 뮤테이션 훅.
 * 백엔드 프록시를 통해 카카오 주소 검색 API를 호출한다.
 *
 * @example
 * const { mutate, data } = useSearchAddress()
 * mutate('수원시 영통구')
 */
export function useSearchAddress() {
  return useMutation({
    mutationFn: async (query: string): Promise<LocationSearchResult[]> => {
      const response = await apiClient.get<ApiResponse<LocationSearchResult[]>>(
        '/location/search',
        { params: { query } }
      )
      return response.data.data
    },
  })
}
